import { ComponentProps, useId, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { ClearAllDropdownItem } from 'routes/essential-workspace/components/clear-all-item';
import { ImportQuoteDropdownItem } from 'routes/essential-workspace/components/import-quote-item';

function CustomToggle({ ...props }: Omit<ComponentProps<'button'>, 'type' | 'className'>) {
  return <button {...props} type="button" className="btn btn-flat-secondary btn-lg btn-icon" />;
}

type EssentialMoreMenuProps = {
  onAddTab: () => void;
};

export function EssentialMoreMenu({ onAddTab }: EssentialMoreMenuProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleId = useId();
  const menuId = useId();

  return (
    <Dropdown show={isMenuOpen} onToggle={setIsMenuOpen}>
      <Dropdown.Toggle
        as={CustomToggle}
        id={toggleId}
        aria-controls={menuId}
        aria-haspopup="menu"
        aria-label="Side panel quote actions"
      >
        <i className="icon" aria-hidden="true">
          more_vert
        </i>
      </Dropdown.Toggle>

      <Dropdown.Menu id={menuId} aria-labelledby={toggleId} role="menu">
        <Dropdown.Item as="button" role="menuitem" onClick={onAddTab}>
          <FormattedMessage id="addWorkspaceTab" />
        </Dropdown.Item>
        <ImportQuoteDropdownItem />
        <Dropdown.Divider />
        <ClearAllDropdownItem />
      </Dropdown.Menu>
    </Dropdown>
  );
}
